'use strict';

var _ = require('lodash');
var userPrefixes = ['userValue', 'user'];
var effPrefix = 'effective';
var calcPrefix = 'calculated';
var usrTypePrefix = 'userType';
var usrValuePrefix = userPrefixes[0];
var basePrefix = 'base';
var segClassPrefix = 'SegClass';
var startRtpPrefix = 'startRtp';
var mappedPrefixes = ['mapped', 'Mapped'];
var regularPrefixes = ['regular', 'Regular'];
var DEMAND_TO_RTP_FIELD_MAP = {
  userValueRegularRemainingDemandFC: 'startRtpRegularRemainingDemandFC',
  userValueMappedRemainingDemandFC: 'startRtpMappedRemainingDemandFC',
  userTypeRegularRemainingDemandFC: 'startRtpRegularRemainingDemandFC',
  userTypeMappedRemainingDemandFC: 'startRtpMappedRemainingDemandFC'
};
var RTP_TO_DEMAND_FIELD_MAP = _.invert(DEMAND_TO_RTP_FIELD_MAP);
var fieldsToRenormalize = ['userRegularAggregateShare', 'userMappedAggregateShare'];
var userSegment = {
  limit: 'userSegmentLimitResSys',
  type: 'userSegmentLimitType'
};
var link = {
  auth: 'userAuthLink',
  regularAuth: 'userRegularAuthLink',
  avail: 'userAvailLink',
  regularAvail: 'userRegularAvailLink',
  linkType: 'linkType',
  linkValue: 'linkValue'
};
var userOverrides = {
  userMaxAuthorization: 'userMaxAuthorization',
  userRegularMaxAuthorization: 'userRegularMaxAuthorization',
  userMinAuthorization: 'userMinAuthorization',
  userRegularMinAuthorization: 'userRegularMinAuthorization',
  userSegClassMaxAuthorization: 'userSegClassMaxAuthorization',
  userSegClassMinAuthorization: 'userSegClassMinAuthorization',
  userMinAvailability: 'userMinAvailability',
  userRegularMinAvailability: 'userRegularMinAvailability',
  userMaxAvailability: 'userMaxAvailability',
  userRegularMaxAvailability: 'userRegularMaxAvailability',
  userSegClassMinAvailability: 'userSegClassMinAvailability',
  userSegClassMaxAvailability: 'userSegClassMaxAvailability',
  hardOverrideType: 'hardOverrideType',
  hardOverrideMinValue: 'hardOverrideMinValue',
  hardOverrideMaxValue: 'hardOverrideMaxValue',
  isManuallyControlled: 'isManuallyControlled'
};
var adjacentTypesMap = {
  userMinAuthorization: userOverrides.userMaxAuthorization,
  userRegularMinAuthorization: userOverrides.userRegularMaxAuthorization,
  userMaxAuthorization: userOverrides.userMinAuthorization,
  userRegularMaxAuthorization: userOverrides.userRegularMinAuthorization,
  userMinAvailability: userOverrides.userMaxAvailability,
  userRegularMinAvailability: userOverrides.userRegularMaxAvailability,
  userMaxAvailability: userOverrides.userMinAvailability,
  userRegularMaxAvailability: userOverrides.userRegularMinAvailability,
  userSegClassMinAuthorization: userOverrides.userSegClassMaxAuthorization,
  userSegClassMaxAuthorization: userOverrides.userSegClassMinAuthorization,
  userSegClassMinAvailability: userOverrides.userSegClassMaxAvailability,
  userSegClassMaxAvailability: userOverrides.userSegClassMinAvailability
};
var renormalizeDependencies = {
  userRegularAggregateShare: ['regularRemainingDemandFC'],
  userMappedAggregateShare: ['mappedRemainingDemandFC']
};
var stripFlowType = new RegExp(mappedPrefixes.join('|') + '|' + regularPrefixes.join('|'), 'g');
var stripUser = new RegExp(usrTypePrefix + '|' + userPrefixes.join('|') + '|' + effPrefix + '|' + calcPrefix + '|' + startRtpPrefix, 'g');
var stripSegClass = new RegExp(segClassPrefix, 'g');
var isMapped = new RegExp(mappedPrefixes.join('|'), 'g');
var isRegular = new RegExp(regularPrefixes.join('|'), 'g');
var OverridesConstants = {
  USER_PREFIXES: userPrefixes,
  MAPPED_PREFIXES: mappedPrefixes,
  REGULAR_PREFIXES: regularPrefixes,
  EFFECTIVE_PREFIX: effPrefix,
  CALCULATED_PREFIX: calcPrefix,
  USER_TYPE_PREFIX: usrTypePrefix,
  USER_VALUE_PREFIX: usrValuePrefix,
  BASE_PREFIX: basePrefix,
  DEMAND_TO_RTP_FIELD_MAP: DEMAND_TO_RTP_FIELD_MAP,
  RTP_TO_DEMAND_FIELD_MAP: RTP_TO_DEMAND_FIELD_MAP,
  FIELDS_TO_RENORMALIZE: fieldsToRenormalize,
  RENORMALIZE_DEPENDENCIES: renormalizeDependencies,
  ADJACENT_TYPES_MAP: adjacentTypesMap,
  USER_SEGMENT_LIMIT: userSegment.limit,
  USER_SEGMENT_LIMIT_TYPE: userSegment.type,
  AUTH_LINK: link.auth,
  REGULAR_AUTH_LINK: link.regularAuth,
  AVAIL_LINK: link.avail,
  REGULAR_AVAIL_LINK: link.regularAvail,
  LINK_TYPE: link.linkType,
  LINK_VALUE: link.linkValue,
  USER_MIN_AUTHORIZATION: userOverrides.userMinAuthorization,
  USER_REGULAR_MIN_AUTHORIZATION: userOverrides.userRegularMinAuthorization,
  USER_MAX_AUTHORIZATION: userOverrides.userMaxAuthorization,
  USER_REGULAR_MAX_AUTHORIZATION: userOverrides.userRegularMaxAuthorization,
  USER_SEG_CLASS_MIN_AUTHORIZATION: userOverrides.userSegClassMinAuthorization,
  USER_SEG_CLASS_MAX_AUTHORIZATION: userOverrides.userSegClassMaxAuthorization,
  USER_MAX_AVAILABILITY: userOverrides.userMaxAvailability,
  USER_REGULAR_MAX_AVAILABILITY: userOverrides.userRegularMaxAvailability,
  USER_MIN_AVAILABILITY: userOverrides.userMinAvailability,
  USER_REGULAR_MIN_AVAILABILITY: userOverrides.userRegularMinAvailability,
  USER_SEG_CLASS_MAX_AVAILABILITY: userOverrides.userSegClassMaxAvailability,
  USER_SEG_CLASS_MIN_AVAILABILITY: userOverrides.userSegClassMinAvailability,
  HARD_OVERRIDE_TYPE: userOverrides.hardOverrideType,
  HARD_OVERRIDE_MIN_VALUE: userOverrides.hardOverrideMinValue,
  HARD_OVERRIDE_MAX_VALUE: userOverrides.hardOverrideMaxValue,
  IS_MANUALLY_CONTROLLED: userOverrides.isManuallyControlled,
  STRIP_FLOW_TYPE: stripFlowType,
  STRIP_USER: stripUser,
  STRIP_SEG_CLASS: stripSegClass,
  IS_MAPPED: isMapped,
  IS_REGULAR: isRegular,
  DEFAULT_TYPE: 'A',
  START_RTP_PREFIX: startRtpPrefix
};
module.exports = OverridesConstants;